import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_MEETING_REQUEST_LIST_ID");

const expand =
  "expand=fields(select=Title, eName, eParticipants, eNumParticipants, eMeetingTime, eDescription, eFileContent, eDeptHeadComment, eITLeadComment, eITHeadComment,eApprovalComments, eAssigneeComment, eApprovedBy,eApprovedName, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eDepartment, eUnit, ePhoneNumber, eComments, ePins)";
export class MeetingRequestService {
  //SystemCode: ---MR---
  //MailCode: MRRA - MRRF - MRRR
  //eDescription: Nội dung cuộc họp

  static async getMeetingRequests(email: string, status?: string) {
    if (
      email.toLowerCase() === "botit@viags.vn" ||
      email.toLowerCase() === "huongptt@viags.vn" ||
      email.toLowerCase() === "hieptd@viags.vn" ||
      email.toLowerCase() === "anhttt@viags.vn" ||
      email.toLowerCase() === "thiennv@viags.vn" ||
      email.toLowerCase() === "huongdtt@viags.vn"
    ) {
      return api
        .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
        .then((res) => res.data.value.reverse())
        .catch((err) => {
          throw new RequestError(err);
        });
    } else {
      let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
      return api
        .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`))
        .then((res) => res.data.value.reverse())
        .catch((err) => {
          throw new RequestError(err);
        });
    }
  }

  static async getMyMeetingRequests(email: string) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then((res) =>
        res.data.value.filter((o: any) => o.createdBy.user.email.toLowerCase() === email.toLowerCase()).reverse(),
      )
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMeetingRequest(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async addMeetingRequest(leaveRequest: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateMeetingRequest(id: any, fields: any) {
    return api
      .patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async deleteMeetingRequest(id: any) {
    return api
      .delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}
